// extracted by mini-css-extract-plugin
export default {"play":"Play_play__Odd77","small":"Play_small__YmpBX"};